import { Box } from '@mui/material';
import sanitizeHtml from 'sanitize-html';

interface RestrictedRawHTMLProps {
  html: string;
}

const RestrictedRawHTML = ({ html }: RestrictedRawHTMLProps) => {
  const cleanHtml = sanitizeHtml(html, {
    allowedTags: ['b', 'i', 'em', 'strong', 'a', 'p', 'ul', 'ol', 'li', 'br'],
    allowedAttributes: {
      a: ['href', 'target', 'rel'],
    },
    allowedSchemes: ['http', 'https', 'mailto'],
    allowedSchemesByTag: {},
    transformTags: {
      a: sanitizeHtml.simpleTransform('a', { rel: 'noopener noreferrer', target: '_blank' }),
    },
  });

  return (
    <Box
      sx={{
        '& ul': {
          paddingLeft: 2,
          marginTop: 1,
          marginBottom: 1,
          listStylePosition: 'outside',
          listStyleType: 'disc',
        },
        '& li': {
          marginBottom: 0.5,
        },
      }}
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
    />
  );
};

export default RestrictedRawHTML;
